<template>
  <b-card>
    <b-card-title class="mb-1 d-flex align-items-center">
      <span style="margin-left: 5px">Produktivitas Operator</span>
    </b-card-title>
    <loader v-if="loading" />
    <b-table v-else-if="users.length > 0" :items="users" :fields="fields" striped hover responsive>
      <template #cell(success_rate)="data">
        {{ parseFloat(data.value || 0).toFixed(2) }}%
      </template>
      <template #cell(last_activity)="data">
        {{ formatDate(data.value) }}
      </template>
    </b-table>
    <div v-else class="text-center py-5">
      <p class="text-muted">Tidak ada data produktivitas.</p>
    </div>
  </b-card>
</template>
<script>
import loader from "@/views/components/loader.vue";
import moment from "moment";
import { BTable } from "bootstrap-vue";

export default {
  name: "SmdTopUserTable",
  components: { loader, BTable },
  props: {
    loading: { type: Boolean, default: false },
    users: { type: Array, default: () => [] },
  },
  data() {
    return {
      fields: [
        { key: "username", label: "Operator", sortable: true },
        { key: "fanpage_synced", label: "Postingan Synced", sortable: true },
        { key: "accounts_synced", label: "Akun Synced", sortable: true },
        { key: "success_rate", label: "Success Rate", sortable: true },
        { key: "last_activity", label: "Aktivitas Terakhir", sortable: true },
      ],
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "-";
      return moment(dateStr).format("DD MMM YYYY HH:mm");
    }
  }
};
</script>
